export class RequestCreateViewConfiguration {}
